import { useSelector } from 'react-redux';

export const useAvailableActions = () => {
  const availableActions = useSelector((state) => state.app.availableActions);
  const allowedReportKeys = useSelector((state) => state.app.allowedReportKeys) || [];
  const reportKeysLoaded = useSelector((state) => state.app.reportKeysLoaded);

  const hasAction = (action) => {
    return availableActions.includes(action);
  };

  const canAccessReport = (reportKey) => allowedReportKeys.includes(reportKey);

  return {
    availableActions,
    allowedReportKeys,
    reportKeysLoaded,
    hasAction,
    canAccessReport,
    canReadProfiles:  hasAction('READ_PROFILES'),
    canReadProfile: hasAction('READ_PROFILE'),
    canReadReports: hasAction('READ_REPORTS'),
    canEditProfile: hasAction('EDIT_PROFILE'),
    canCreateProfile: hasAction('CREATE_PROFILE'),
    canReadUsers: hasAction('READ_USERS'),
    canCreateUsers: hasAction('CREATE_USERS'),
    canReadSites: hasAction('READ_SITES'),
    canEditSites: hasAction('EDIT_SITES'),
    canEditAccounts: hasAction('EDIT_ACCOUNTS'),
    canReadEvents: hasAction('READ_EVENTS'),
    canDeleteProfile: hasAction('DELETE_PROFILE'),
    canReadAdminReports: hasAction('READ_ADMIN_REPORTS'),
    canPerformProfileAdminActions: hasAction('PROFILE_ADMIN_ACTIONS'),
    canReadBoscaAdminReports: hasAction('READ_BOSCA_ADMIN_REPORTS'),
  };
};
